import { bootstrapApplication } from '@angular/platform-browser';

import { Amplify } from 'aws-amplify';
import awsExports from './app/auth/aws-exports';

import { App } from './app/app';
import { appConfig } from './app/app.config';

// Configure AWS Amplify for Cognito authentication
//console.log('Amplify config:', awsExports);
Amplify.configure(awsExports as any);

bootstrapApplication(App, appConfig).catch(err => console.error(err));




